/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const Favourite = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 22 20">
      <path
        d="M5.486.846C2.496 1.372.421 4.075.657 7.136c.174 2.264 1.237 4.431 3.306 6.742 1.444 1.612 3.661 3.437 5.827 4.795.761.478.926.553 1.21.553.284 0 .449-.075 1.21-.553 2.929-1.837 5.527-4.17 7.113-6.388 1.652-2.312 2.355-4.851 1.909-6.896A5.873 5.873 0 0 0 16.485.844a6.915 6.915 0 0 0-1.868-.019 5.886 5.886 0 0 0-3.297 1.677l-.322.322-.32-.322A5.88 5.88 0 0 0 7.383.825a7.298 7.298 0 0 0-1.897.021m1.667 1.963a3.937 3.937 0 0 1 2.351 1.368c.145.181.337.485.471.75.275.542.362.661.56.764.307.162.855.059 1.134-.213.078-.075.235-.321.362-.568.276-.534.616-.965 1.01-1.28a3.899 3.899 0 0 1 2.631-.869 3.834 3.834 0 0 1 3.051 1.733c.402.604.588 1.177.625 1.926.087 1.787-.783 3.786-2.544 5.841-.892 1.042-2.388 2.4-3.791 3.442-.629.468-1.943 1.347-2.013 1.347-.07 0-1.384-.879-2.013-1.347-1.414-1.05-2.887-2.387-3.791-3.442-1.759-2.052-2.631-4.054-2.544-5.841.046-.941.377-1.728 1.028-2.446.841-.926 2.202-1.383 3.473-1.165"
        fillRule="evenodd"
      />
    </BaseSvgIcon>
  )
}

export default Favourite
